import { render, staticRenderFns } from "./CUR-DIS-95.vue?vue&type=template&id=05d452c6&scoped=true&"
import script from "./CUR-DIS-95.vue?vue&type=script&lang=js&"
export * from "./CUR-DIS-95.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d452c6",
  null
  
)

export default component.exports